import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { exportFile, FileType } from "../../utils/export-file";
import { PartnerService } from "./partner.service";

type ExportDataRequest = {
    url: string
    params: Record<string, string>
}

interface ExportDataResponse {
    file: string
}

@Injectable({
    providedIn: 'root'
})
export class ExportsService {
    private readonly api = 'https://api.dev.marketplace.totvs.io/dev'
    constructor(
        private http: HttpClient,
        private partnerService: PartnerService
    ) {}

    exportData({ params, url }: ExportDataRequest) {
        const partnerId = this.partnerService.getCurrentPartner() ?? '';

        this.http.get<ExportDataResponse>(`${this.api}/${url}`, {
            params: { ...params },
            headers: { 'x-partner-id': partnerId }
        }).subscribe((res) => {
            exportFile(res.file)
        });
    }
}